import { Inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Route } from '@angular/router';

import { OpportunityPermissionsService } from '@app/opportunities/services/opportunity-permissions.service';
import { WindowToken } from '@degreed/lxp/services';
import { AuthService, AuthUser } from '@degreed/lxp/services/authorization';

@Injectable()
export class OpportunitiesViewGuardService {
  constructor(
    private authService: AuthService,
    private opportunityPermissionsService: OpportunityPermissionsService,
    @Inject(WindowToken) private windowRef: Window
  ) {}

  /**
   * Authorizes route activation.
   */
  public canActivate(
    route: ActivatedRouteSnapshot
  ): boolean | Promise<boolean> {
    return this.checkUser(this.authService.authUser);
  }

  /**
   * Authorizes route loading. Should be used on routes that require higher security,
   * as this keeps the route data from being accessible to the user in any way.
   */
  public canLoad(_: Route): boolean | Promise<boolean> {
    return this.checkUser(this.authService.authUser);
  }

  private checkUser(authUser: AuthUser): boolean | Promise<boolean> {
    if (this.opportunityPermissionsService.canViewOpportunities(authUser)) {
      return true;
    }
    // TODO: We *should* be able to just return false here, but
    // that alone doesn't redirect correctly. Using router here
    // to navigate doesn't work either, since the paths we're
    // trying to redirect *to* are outside of the router.
    this.windowRef.location.assign('/');
    return false;
  }
}
